<template>
  <v-container>
    <v-layout justify-center>
      <v-flex lg6>
        <jti-expansion-panel panelName="Bound Details">
          <v-form v-model="valid" ref="form" lazy-validation>
            <v-container grid-list-lg>
              <v-text-field
                v-model="data.name"
                label="Name"
                :readonly="readonly"
                required
                :rules="[rules.required]"
              ></v-text-field>
              <v-text-field
                v-model="data.code"
                label="Code"
                :readonly="readonly"
                required
                :rules="[rules.required]"
              ></v-text-field>
              <!-- <v-text-field v-model="data.city" label="City" :readonly="readonly"></v-text-field> -->
              <!-- <v-text-field v-model="data.province" label="Province" :readonly="readonly"></v-text-field> -->
            </v-container>
          </v-form>
        </jti-expansion-panel>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  props: {
    data: Object,
    readonly: Boolean
  },
  computed: {
    computedData() {
      return {
        id: this.data.id,
        name: this.data.name,
        code: this.data.code
        // city: this.data.city,
        // province: this.data.province
      };
    }
  },
  data() {
    return {
      valid: true,
      rules: {
        required: value => !!value || "This field is required.",
        counter: value => value.length <= 20 || "Max 20 characters",
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        }
      }
    };
  },
  methods: {
    clear() {
      this.$refs.form.reset();
    },
    validateForm() {
      return this.$refs.form.validate();
    }
  }
};
</script>

<style>
</style>
